var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBbExclamationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI:_Component_197",
    "data-name": "UI: Component 197",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#c83730",
    opacity: 0.999
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon:_Info",
    "data-name": "Icon: Info",
    transform: "translate(25.147 28.189) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1,11.032H-1V0H1Z",
    transform: "translate(10.147 9.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1,2.207H-1V0H1Z",
    transform: "translate(10.147 5.413)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbExclamationRed);
export default __webpack_public_path__ + "static/media/bb-exclamation_red.76a196bdbcd52ff54a0c4f35bac767a9.svg";
export { ForwardRef as ReactComponent };